import {useHistory, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

import {useMainTranslation} from "../../../../../newShared/hooks/useMainTranslationHooks/useMainTranslation";
import {
    assetsDialogsSelector,
    deselectSaasAsset,
    loadings,
    saasAssetsSettingsSelector,
    selectedSaas,
    setCreateSettingRowDialogAction,
    setDeleteAssetDialogAction,
} from "../../store/store";
import {PATH_LOCAL_ASSET_MANAGEMENT_SAAS, PATH_LOCAL_ASSET_MANAGEMENT_SAAS_ID,} from "../../constants";
import {GetSaasAssetById, getSaasAssetsSettingsAction, updateSaasAssetAction,} from "../../store/actions";
import {useSetBreadcrumbs} from "../../../../barsEnvironment/breadcrumbs/hooks/useBreadcrumbs";
import {PATH_LOCAL_ASSET_MANAGEMENT} from "../../../../../newShared/constants";
import {TExactAssetTabs, TSaasAsset, TSetCreateSettingRowDialog, TSetDeleteAssetDialog,} from "../../types";
import {useForm} from "../../../../../newShared/hooks/useForm";


export const useSaasExact = () => {
    const {t: tMenu} = useMainTranslation('', {keyPrefix: 'LeftMenu'});
    const dispatch = useDispatch();
    const history = useHistory();
    const id = useParams<{id: string}>().id;
    const _selected = useSelector(selectedSaas);
    const settings = useSelector(saasAssetsSettingsSelector);
    const {isLoadingExact, isLoadingSettings} = useSelector(loadings);
    const {deleteAsset: {response: responseDelete}} = useSelector(assetsDialogsSelector);


    const handleGoBack = () => {
        history.push(PATH_LOCAL_ASSET_MANAGEMENT_SAAS);
    }

    const controller = new AbortController();

    const [editInfoMode, setEditInfoMode] = useState<boolean>(false);
    const [oldId, setOldId] = useState<string>('');


    //form
    const {form, setForm, handleChange} = useForm<TSaasAsset | null>(null);


    useEffect(() => {
        if(!_selected){
            dispatch(GetSaasAssetById({data: {id, onError: handleGoBack}, signal: controller.signal}));
        }
        if(!settings) {
            dispatch(getSaasAssetsSettingsAction({data: {organizationId: '', workspaceId: ''}, signal: controller.signal}))
        }
        if(_selected) setForm(_selected);

        return () => {
            dispatch(deselectSaasAsset());
            setForm(null);
            setOldId('');
            setEditInfoMode(false);
            controller.abort();
        }
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        if(settings && settings.customFields){
            const customFields: { [key: string]: string } = {};
            Object.keys(settings.customFields).length && Object.keys(settings.customFields).forEach((key) => form?.customFields?.[key] ? form.customFields?.[key] : customFields[key] = '');
            setForm(prev => prev && ({...prev, customFields}));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [settings]);

    useEffect(() => {
        if (_selected && _selected?.id !== id) history.push(`${PATH_LOCAL_ASSET_MANAGEMENT_SAAS_ID.replace(':id', _selected?.id)}`);

        //eslint-disable-next-line
    }, [_selected?.id]);

    useSetBreadcrumbs([
        {
            title: tMenu('Asset Management'),
            path: PATH_LOCAL_ASSET_MANAGEMENT
        },
        {
            // title: tMenu('Saas'),
            title: 'Saas',
            path: PATH_LOCAL_ASSET_MANAGEMENT_SAAS
        },
        {
            title: _selected ? _selected.name : 'Loading...',
            path: _selected ? PATH_LOCAL_ASSET_MANAGEMENT_SAAS_ID.replace(':id', _selected.id) : undefined
        },
    ]);

    //MENU
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const isOk = () => {
        return (form && form.name.trim().length > 0 && form.id.length)
    }

    //tabs
    const [tab, setTab] = useState<TExactAssetTabs>('information');

    //actions
    const handleSaveInfo = () => {
        form && dispatch(updateSaasAssetAction({
            workspaceId: '',
            organizationId: '',
            asset: {...form, seeds: Number(form.seeds), licenses: Number(form.licenses)},
            assetId: oldId
        }));
        setEditInfoMode(false);
    }

    const handleCancelEditInfo = () => {
        setForm(null);
        setEditInfoMode(false)
    }

    const handleEditInfoBtn = () => {
        setEditInfoMode(true);
        if (_selected) {
            setOldId(_selected.id);
            setForm({..._selected, customFields: _selected.customFields ? _selected.customFields : {}});
        }
    }

    //Dialogs
    const setDeleteAssetDialog = (data: TSetDeleteAssetDialog) => {dispatch(setDeleteAssetDialogAction(data))};

    const handleSetBillingCycle = (title: string) => {
        setForm(prev => prev && ({...prev, billingCycle: title}));
    }

    const setCreateSettingRowDialog = (data: TSetCreateSettingRowDialog) => {dispatch(setCreateSettingRowDialogAction(data))};

    const handleChangeCustomField = (event:React.ChangeEvent<HTMLInputElement>) => {
        event.persist();
        setForm((prev) => prev && ({
            ...prev,
            customFields: {
                ...prev.customFields,
                [event.target.name]: event.target.value,
            },
        }));
    };

    return {
        isOk,
        asset: _selected,
        settings,
        menu: {
            anchorEl,
            handleClose,
            handleClick,
            open,
        },
        tab,
        setTab,
        handleGoBack,

        isLoadingExact,
        isLoadingSettings,

        editInfoMode,
        setEditInfoMode,
        form,
        handleChange,
        handleSetBillingCycle,
        oldId,
        setOldId,
        handleSaveInfo,
        handleCancelEditInfo,
        handleEditInfoBtn,
        setCreateSettingRowDialog,
        handleChangeCustomField,
        deleteAssetDialog: {setDeleteAssetDialog, responseDelete},

    }

}
